/*
 * Organic Promise: product FAQs into the FAQs tab (31 Oct 2026).
 * op-theme.js splits the product description into dropdowns and puts anything
 * it doesn't recognise (including the "Questions about ..." section) under
 * "Details". This moves that section to the top of the "FAQs" dropdown, above
 * the ordering and delivery questions. The description itself is unchanged, so
 * search engines still see the same text. Runs after op-theme.js.
 */
(function () {
  'use strict';

  var FAQ_HEADING = /^\s*(questions about|faqs?\b|frequently asked questions)/i;

  function summaryText(details) {
    var s = details.querySelector('summary');
    return s ? s.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
  }

  function hasText(el) {
    return el.textContent.replace(/\s+/g, '').length > 0 || el.querySelector('img, video, iframe');
  }

  function moveFaqs() {
    document.querySelectorAll('[data-op-details]').forEach(function (root) {
      if (root.dataset.opFaqDone) return;
      var accordions = root.querySelector('[data-op-accordions]');
      if (!accordions) return;
      var all = Array.prototype.slice.call(accordions.querySelectorAll(':scope > details.op-acc'));
      var detailsAcc = all.filter(function (d) { return summaryText(d) === 'details'; })[0];
      var faqAcc = all.filter(function (d) { return summaryText(d) === 'faqs'; })[0];
      if (!detailsAcc || !faqAcc) return;
      var detailsBody = detailsAcc.querySelector('.op-acc__body');
      var faqBody = faqAcc.querySelector('.op-acc__body');
      if (!detailsBody || !faqBody) return;

      var heading = Array.prototype.filter.call(detailsBody.querySelectorAll('h2, h3, h4'), function (h) {
        return FAQ_HEADING.test(h.textContent || '');
      })[0];
      if (!heading) return;

      var level = Number(heading.tagName.charAt(1));
      var moved = document.createDocumentFragment();
      var node = heading.nextSibling;
      while (node) {
        var next = node.nextSibling;
        if (node.nodeType === 1 && /^H[1-6]$/.test(node.tagName) && Number(node.tagName.charAt(1)) <= level) break;
        moved.appendChild(node);
        node = next;
      }
      heading.parentNode.removeChild(heading);
      if (!moved.childNodes.length) return;

      faqBody.insertBefore(moved, faqBody.firstChild);
      if (!hasText(detailsBody)) detailsAcc.parentNode.removeChild(detailsAcc);
      root.dataset.opFaqDone = '1';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', moveFaqs);
  else moveFaqs();
})();
